<script setup lang="ts">

</script>

<template>
  <div class="accepted-invite-tost-icon">
    <svg
      class="shadow-icon"
      width="64"
      height="55"
      viewBox="0 0 64 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="30"
        cy="27.5"
        rx="34"
        ry="27.5"
        fill="url(#paint0_radial_7412_38431)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_7412_38431"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(30 27.5) scale(34 27.5)"
        >
          <stop
            stop-color="#FFB347"
            stop-opacity="0.35"
          />
          <stop
            offset="1"
            stop-color="#FFB347"
            stop-opacity="0"
          />
        </radialGradient>
      </defs>
    </svg>
    <img
      src="/images/village/accepted-invite-tost-icon.png"
      class="image-icon"
    >
  </div>
</template>

<style scoped>
.accepted-invite-tost-icon {
  position: relative;
}

.image-icon {
  width: 100%;
  height: 100%;
}

.shadow-icon {
  position: absolute;
  top: -30%;
  left: -30%;
  width: 160%;
  height: 160%;
}

</style>
